import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class AppConfigService {
  private dynamicConfig: any = {};

  constructor(private http: HttpClient) {}

  loadConfig(): Promise<void> {
    const configUrl = environment.api_service_users.replace('/users', '/config/public');
    
    return new Promise((resolve) => {
      this.http.get(configUrl).subscribe({
        next: (data) => {
          this.dynamicConfig = data;
          resolve();
        },
        error: (err) => {
          console.error('[AppConfig] Error cargando config dinámica. Usando .env de fallback', err);
          resolve(); // Resolvemos siempre para no bloquear el arranque
        }
      });
    });
  }

  // Ejemplo de uso: this.appConfig.get('UI_THEME')
  get(key: string): any {
    return this.dynamicConfig[key];
  }
}